import { ELEVAR_INVALIDATE_CONTEXT_TIMEOUT_MS } from '@/lib/elevar/constants';

let contextConsumed = false;

/**
 * First pageview waits for Elevar's script to load. Later SPA navigations
 * invalidate its prior-route context, timed out and error-swallowed so a
 * hung/rejected ElevarInvalidateContext can't stall pageview events for
 * the rest of the session.
 */
export async function elevarEnsureContext() {
  if (typeof window === 'undefined') return;

  await (window.__elevarReady ?? Promise.resolve());

  if (contextConsumed) {
    let timeoutId;
    await Promise.race([
      Promise.resolve(window.ElevarInvalidateContext?.()).catch(() => {}),
      new Promise((resolve) => { timeoutId = setTimeout(resolve, ELEVAR_INVALIDATE_CONTEXT_TIMEOUT_MS); }),
    ]);
    clearTimeout(timeoutId);
  }

  contextConsumed = true;
}
